import React, { useEffect, useState } from 'react';
import { KiteIcon } from '@kite/react-kite';
import './ArticleShare.scss';
import { ReachButton } from '../../../components/ReachButton/ReachButton';

export const ArticleShare = ({ title }) => {
    const [url, setUrl] = useState<string>(``);

    useEffect(() => {
        const isBrowser = typeof window !== `undefined`;
        if (isBrowser) {
            setUrl(window.location.href);
        }
    }, [url, setUrl]);

    return (
        <div className="share-container">
            <h4 className="typestack-title-6">Share:</h4>
            <ul className="social">
                <li>
                    <a
                        href={`mailto:?body=${url}`}
                        target="_blank"
                        aria-label="Share this article via email"
                    >
                        <KiteIcon size="2rem" icon="ki-mail" />
                    </a>
                </li>
                <li>
                    <a
                        target="_blank"
                        href={`https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}`}
                        aria-label="Share this article on Facebook"
                    >
                        <KiteIcon size="2rem" icon="ki-facebook" />
                    </a>
                </li>
                <li>
                    <a
                        href={`https://twitter.com/share?url=${url}`}
                        className="twitter-share-button"
                        aria-label="Share this article on Twitter"
                        target="_blank"
                    >
                        <KiteIcon size="2rem" icon="ki-x-twitter" />
                    </a>
                </li>
                <li>
                    <a
                        href={`https://linkedin.com/share?url=${url}`}
                        aria-label="Share this article on LinkedIn"
                        target="_blank"
                    >
                        <KiteIcon size="2rem" icon="ki-linkedin" />
                    </a>
                </li>
                <li>
                    <ReachButton
                        buttonStyle="borderless"
                        title="Copy this article url"
                        aria-label="Copy this article url"
                        onClick={() => navigator.clipboard.writeText(url)}
                    >
                        <KiteIcon size="2rem" icon="ki-link" />
                    </ReachButton>
                </li>
            </ul>
        </div>
    );
};
